import { siteSettings } from '@components/settings/constants';

export function formatNumber(amount: number, localeCode = "en-US", digit = 2) {
  const formatCurrency = new Intl.NumberFormat(localeCode, {
    minimumFractionDigits: digit,
    maximumFractionDigits: digit
  });

  return formatCurrency.format(amount);
}

export function formatPrice({
  amount,
  currencyCode = siteSettings.currencyCode,
}: {
  amount: number;
  currencyCode?: string;
}) {
  const formatCurrency = new Intl.NumberFormat(siteSettings.locale, {
    style: 'currency',
    currency: currencyCode,
  });

  return formatCurrency.format(amount);
}

export function formatCurrencyPrice(amount: number) {
  return `${formatNumber(amount)} ${siteSettings.currencySymbol}`;
}

export function formatCartSubtotal(amount: string) {
  const numbers = amount.replace(/,/g,'').split('.');

  if(amount == '0') return `0 ${siteSettings.currencySymbol}`;

  if(amount.includes('k') || amount.includes('mil')) return `${amount} ${siteSettings.currencySymbol}`;

  if(numbers[0].length == 0) return `0 ${siteSettings.currencySymbol}`;

  if(numbers[0].length <= 4 && numbers[0].length > 0) return `${Math.round(Number(numbers[0])/100)/10}k ${siteSettings.currencySymbol}`;

  if(numbers[0].length > 4 && numbers[0].length <= 6) return `${Math.round(Number(numbers[0])/1000)}k ${siteSettings.currencySymbol}`;

  return `${Math.round(Number(numbers[0])/100000)/10}mil ${siteSettings.currencySymbol}`;
}
